/**
 * @description user store
 */
import config from '../../config'
import getters from '../getters/userGetters'
import mutations from '../mutations/userMutation'
import actions from '../actions/userAction'
import { getUrlParam } from '../../utils/'

/**
 * @description 发票类型
 * 0 不开发票
 * 1 纸质发票
 * @description 发票抬头
 * 1 个人
 * 2 公司
 */

const state = {

}

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}
